// extracted by mini-css-extract-plugin
export var changeIcon = "_6o-4";
export var container = "_6o-0";
export var divider = "_6o-7";
export var externalLinkIcon = "_6o-1";
export var green = "_6o-5";
export var helpCircleIcon = "_6o-3";
export var iconButton = "_6o-2";
export var red = "_6o-6";